import { useSelector } from 'reduxState/store';

/**
 * Returns whether the current view should be considered a mobile device
 * @example
 *  const isMobile = useIsMobile();
 */
export function useIsMobile() {
  const isMobile = useSelector(state => state.screen.isMobile);
  return isMobile;
}

/**
 * Only returns true if the device is an actual mobile device.  This also
 * works with the web inspector simulations (after refresh) since they emulate
 * on the user agent as well.
 */
// export function detectMobileStrict() {
//   if (
//     /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
//       window.navigator.userAgent ?? ''
//     )
//   ) {
//     return true;
//   }
//   return false;
// }

// export function detectAndroidDevice() {
//   return window.navigator.userAgent.toLowerCase().indexOf('android') > -1;
// }
